export const httpHeaders = {
  authToken: "x-auth-token",
  // Carries a magic link token on API requests; the link itself passes it as the queryParams.magicToken
  // page param, so tokens stay out of request URLs (and therefore out of access logs and Referer headers).
  magicToken: "x-magic-token",
} as const;
